module.exports = __webpack_public_path__ + "img/CAT_CHEMICAL_STANDARD.34a972e9.svg";